import * as yup from "yup"

const tradeGradeSchema = yup.object().shape({
  variety_grade: yup.object().nullable().required("Grade is required"),
  rate: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Rate is required"),
  quantity: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Quantity is required"),
})

const tradeCommodityGradeSchema = yup.object().shape({
  variety_grade: yup.object().nullable().required("Grade is required"),
  rate: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Rate is required"),
  quantity: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Quantity is required"),
})

const expenseSchema = yup
  .object()
  .shape({
    expense_parameter: yup.object().nullable().optional(),
    kind: yup.object().nullable().optional(),
  })
  .test(
    "expense-param-kind-required",
    "Expense type is required when expense parameter is selected",
    function (value) {
      const hasParam =
        value?.expense_parameter != null && value.expense_parameter !== ""
      const hasKind = value?.kind != null && value.kind !== ""
      if (hasParam && !hasKind) {
        return this.createError({
          message:
            "Expense type is required when expense parameter is selected",
        })
      }
      if (hasKind && !hasParam) {
        return this.createError({
          message:
            "Expense parameter is required when expense type is selected",
        })
      }
      return true
    }
  )

export const tradeValidationSchema = yup
  .object()
  .shape({
    kind: yup.string().nullable(),
    material_kind: yup.string().nullable(),
    seller: yup.object().nullable().required("Supplier is required"),
    officer: yup.object().nullable().required("Senior Officer is required"),
    junior_officer: yup.object().nullable(),
    vehicle: yup.object().nullable().required("Vehicle is required"),
    start_date: yup.date().required("Start date is required"),

    commodity: yup
      .object()
      .nullable()
      .when("material_kind", {
        is: "packaging",
        then: schema => schema.required("Commodity is required"),
      }),
    commodity_variety: yup
      .object()
      .nullable()
      .when("material_kind", {
        is: "packaging",
        then: schema => schema.required("Variety is required"),
      }),
    quantity_unit: yup
      .object()
      .nullable()
      .when("material_kind", {
        is: "packaging",
        then: schema => schema.required("Quantity unit is required"),
      }),
    trade_items: yup.array().when("material_kind", {
      is: "packaging",
      then: schema => schema.of(tradeGradeSchema),
    }),

    trade_commodity_items: yup
      .array()
      .of(
        yup.object().shape({
          commodity: yup.object().nullable().required("Commodity is required"),
          commodity_variety: yup
            .object()
            .nullable()
            .required("Variety is required"),
          quantity_unit: yup
            .object()
            .nullable()
            .required("Quantity unit is required"),
          grades: yup
            .array()
            .of(tradeCommodityGradeSchema)
            .min(1, "At least one grade is required"),
        })
      )
      .min(1, "At least one commodity is required"),

    expenses: yup.array().of(expenseSchema).optional(),
  })
  .test(
    "intercompany-parent-batch-required",
    "Batch number is required for all grades in an inter-company transaction",
    function (value) {
      const formValues = value as any
      if (
        formValues?.is_intercompany_transaction !== "yes" ||
        formValues?.parent_trade?.id
      ) {
        return true
      }
      let firstMissingPath: string | null = null
      ;(formValues?.trade_commodity_items || []).forEach(
        (block: any, cIdx: number) => {
          const grades = block.grades?.length ? block.grades : [{}]
          grades.forEach((grade: any, gIdx: number) => {
            if (
              !firstMissingPath &&
              !String(grade?.batch_number ?? "").trim()
            ) {
              firstMissingPath = `trade_commodity_items.${cIdx}.grades.${gIdx}.batch_number`
            }
          })
        }
      )
      if (!firstMissingPath) return true
      return this.createError({
        path: firstMissingPath,
        message:
          "Batch number is required for all grades in an inter-company transaction",
      })
    }
  )
